import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CmsUiDynamicContentQuery } from '@lobos/library';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { AlternateVersion } from '../../../../../services/alternate-version';

@AlternateVersion()
@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent implements OnInit {
  public page$ = this.cmsQuery.errorPage$;

  private readonly response: Response;

  constructor(@Optional() @Inject(RESPONSE) response: Response, protected cmsQuery: CmsUiDynamicContentQuery) {
    this.response = response;
  }

  ngOnInit() {
    // this will only be sent in SSR environment
    if (this.response) {
      this.response.status(404);
    }
  }
}
